import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "sensis-material-ui";
import { IconButton, Divider } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { openInNewTab } from "./UrlUtils";

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1];
};

export default function Footer() {
  const config = useSelector((state) => state.config);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const dismissed = getCookie("migrationBannerDismissed");
    if (!dismissed) {
      setShowBanner(true);
    }
  }, []);

  const handleCloseBanner = () => {
    setShowBanner(false);
    setCookie("migrationBannerDismissed", "true", 7);
  };

  return (
    <>
      {showBanner && (
        <Box
          component="section"
          aria-live="polite"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: "#ffce00",
            color: "#000000",
            textAlign: "center",
            padding: "15px",
            fontSize: "1.5rem",
            zIndex: 30000,
            boxShadow: "0 -2px 8px rgba(0,0,0,0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="p"
            style={{
              margin: 0,
              lineHeight: 1,
              maxWidth: "100%",
              textAlign: "center",
              paddingRight: "40px",
              fontSize: "18px",
              paddingBottom: "unset",
            }}
          >
            <i>
              Please be advised that we are in the process of migrating
              MyAccount to a new platform. If you wish to view or pay your bill,
              please call Client Care on 1800 840 099.
            </i>
          </Typography>

          <IconButton
            onClick={handleCloseBanner}
            aria-label="Close banner"
            style={{
              position: "absolute",
              right: 12,
              top: 8,
              color: "#000",
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}

      <Box pt={1} mt={2}>
        <Divider />
        <Box
          display="flex"
          flexWrap="wrap"
          flexDirection="row"
          mui
          mx="auto"
          width="100%"
        >
          <Box
            mui
            p={1}
            display="flex"
            flex={{ sm: "1 50%", md: "0 auto", lg: "0 15%" }}
            onClick={() => openInNewTab(`${config.thryvUrlPrivacy}`)}
            textAlign="left"
            style={{ cursor: "pointer" }}
          >
            <Typography variant="body1">Privacy Policy</Typography>
          </Box>

          <Box
            mui
            p={1}
            display="flex"
            flex={{ sm: "1 50%", md: "0 auto", lg: "0 15%" }}
            onClick={() => openInNewTab(`${config.thryvUrl}/terms-of-use`)}
            style={{ cursor: "pointer" }}
          >
            <Typography variant="body1">Terms of Use</Typography>
          </Box>

          <Box mui p={1} display="flex" flex={{ sm: "2 0 100%" }}>
            <Typography
              variant="body1"
              component={Box}
              width="100%"
              mui
              textAlign={{ xs: "left", md: "right" }}
            >
              Yellow Pages and its logo are trade marks of Thryv Australia Pty
              Ltd. © 2021 Thryv Australia Pty Ltd. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
